export const CYAN = "cyan";
export const EXTRALARGE = "extralarge";
export const GREEN = "green";
export const GREY = "grey";
export const GREY_BORDER = "greyBorder";
export const LARGE = "large";
export const MEDIUM = "medium";
export const SMALL = "small";
export const WHITE = "white";
